import { postRequest } from 'src/services/requests';

const buscarAplicacoesWeb = (): Promise<{
  success: boolean;
  hash: string;
  messages: string[];
  data: {
    Aplicacoes: [
      {
        Portal: string;
        NomeExibicao: string;
        Nome: string;
        Endereco: string;
        PossuiDireito: boolean;
      }
    ];
  };
}> => {
  return new Promise((resolve, reject) => {
    postRequest(
      '/genericos/ge/ambiente/BuscarAplicacoesWeb?somenteEnderecos=false',
      '',
      resolve,
      reject
    );
  });
};

export { buscarAplicacoesWeb };
